import organizerMeta from '@/router/organizer/organizerMeta.js'

export default [
  {
    path: '/organizer/profile/info',
    name: 'organizer-profile-info',
    meta: organizerMeta,
    component: () => import('@/views/Organizer/Profile/OrganizerProfileInfoView.vue'),
  },
  {
    path: '/organizer/profile/documents',
    name: 'organizer-profile-documents',
    meta: organizerMeta,
    component: () => import('@/views/Organizer/Profile/OrganizerProfileDocumentsView.vue'),
  },
  {
    path: '/organizer/profile/changelog',
    name: 'organizer-profile-changelog',
    meta: organizerMeta,
    component: () => import('@/views/Organizer/Profile/OrganizerProfileChangelogView.vue'),
  },
  {
    path: '/organizer/profile/edit/:id',
    name: 'organizer-profile-edit',
    meta: organizerMeta,
    component: () => import('@/views/Organizer/Profile/OrganizerProfileEditView.vue'),
  },
]
